import React, { useEffect, useState } from "react";
import { useGeneralParams } from "../../../../hooks/useDataPaginate";
import {
  CerrarCuadernosValues,
  CreateValues,
  DeleteValues,
  GeneralUpdateValues,
  UpdateCuadernoValues,
} from "../../../../FormSchemes/CuadernoScheme";
import { formatDateWithTime } from "../../../../utils/dateFormat";
import { MinimalActionButton } from "../../../../components/form/minimalActionButton";
import { ModalPdf } from "../../../../components/modals/ModalPdf";
import RegistroDiarioPdf from "./RegistroDiarioPdf";
import { DefaultParamsForRecall } from "../../../../utils/defaulStates";
import { Callers } from "../../../../hooks/Callers";
import { useSelector } from "react-redux";
import { DefaultMultiSelectVendedores } from "../../../../components/defaults";
import { useParams } from "react-router-dom";

export const ListCuadernoTable = ({
  abierto,
  revisado,
  isAnyShow,
  noSection,
  propio = false,
  onReopen,
  changed,
}) => {
  const {
    dispatch,
    data,
    setData,
    paginate,
    setPaginate,
    selectedDay,
    setSelectedDay,
    selecteds,
    setSelecteds,
    selectAllChecked,
    setSelectAllChecked,
    isChecked,
    setIsChecked,
    stateData,
    setStateData,
    createModal,
    setCreateModal,
    deleteModal,
    setDeleteModal,
    currentData,
    setCurrentData,
    // updateModal, setUpdateModal,
    // deleteModal, setDeleteModal,
    // currentData, setCurrentData,
    // imports
    requestAuthPaginate,
    TableContainer,
    Paginator,
    formatFilters,
    Searcher,
    // FilterSelect,
    RangeDate,
    Actions,
    TableSection,
    ActionSection,
    Section,
    ModalForm,
    UpdateValuesModal,
    redirect,
  } = useGeneralParams({
    aditionals: { rolnames: ["carro-distribuidor", "punto-de-venta"] },
  });
  const [reopenModal, setReopenModal] = useState(false);

  const [cerrarCuadernosModal, setCerrarCuadernosModal] = useState(false);
  const [registroDiarioModal, setRegistroDiarioModal] = useState(false);
  const [actualizarFechaModal, setActualizarFechaModal] = useState(false);
  // const reloadMainTable = useSelector(state => state.login.reloadMainTable)
  const [recall, setRecall] = useState(false);
  const lock = useSelector((state) => state.login.rol?.limitar_permisos);
  const params = useParams();
  const getDataPaginate = async () => {
    await requestAuthPaginate({
      method: "get",
      url: `/cuadernos/pag`,
      data: null,
      queries: paginate,
      setData: setData,
      setStateData: setStateData,
      setQueries: setPaginate,
      dispatch: dispatch,
      aditionalParams: {
        filterBy: "codigo",
        rolname: "",
        abierto: abierto,
        revisado: revisado,
        propio: params.user_vend_id,
      },
    });
  };

  useEffect(() => {
    getDataPaginate();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ...DefaultParamsForRecall(paginate),
    paginate.abierto,
    paginate.rolnames,
    recall,
    changed,
  ]);

  useEffect(() => {
    setSelectAllChecked(false);
    setIsChecked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ...DefaultParamsForRecall(paginate),
    paginate.abierto,
    paginate.rolnames,
    recall,
    changed,
  ]);

  const reloadTable = () => {
    Callers(dispatch);
    setSelecteds([]);
    setSelectAllChecked(false);
    setIsChecked(false);
    setRecall((x) => !x);
  };

  const permitirCuaderno = useSelector(
    (state) => state.authGeneral.permitirCuaderno,
  );

  const Wrapper = noSection ? React.Fragment : Section;
  return (
    <Wrapper>
      <ActionSection>
        <Actions
          buttons={[
            ...(abierto && permitirCuaderno
              ? [
                  {
                    icon: "add",
                    label: "Aperturar cuadernos",
                    action: () => setCreateModal(true),
                  },
                  {
                    icon: "add",
                    label: "Cerrar cuadernos seleccionados",
                    action: () => setCerrarCuadernosModal(true),
                    disabled: selecteds.length <= 0 ? true : false,
                  },
                  {
                    icon: "add",
                    label: "Registro Diario",
                    action: () => setRegistroDiarioModal(true),
                    disabled: selecteds.length <= 0 ? true : false,
                  },
                ]
              : []),
          ]}
        />
        <Searcher
          paginate={paginate}
          setPaginate={setPaginate}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          options={[
            {
              label: "Código",
              value: "codigo",
            },
            {
              label: "Nombre",
              value: "nombre",
            },
          ]}
          reloadTable={() => {
            reloadTable();
          }}
        />
        <div className="flex gap-2 flex-wrap">
          <RangeDate
            selectedDay={selectedDay}
            setSelectedDay={setSelectedDay}
            paginate={paginate}
            setPaginate={setPaginate}
          />
          {/* <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='abierto'
                        options={[
                            {
                                label: 'Abiertos y cerrados',
                                value: ''
                            },
                            {
                                label: 'Abiertos',
                                value: 'true'
                            },
                            {
                                label: 'Cerrados',
                                value: 'false'
                            }
                        ]}
                    />
                    <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='revisado'
                        options={[
                            {
                                label: 'Revisados y pendientes',
                                value: ''
                            },
                            {
                                label: 'Revisados',
                                value: 'true'
                            },
                            {
                                label: 'Pendientes',
                                value: 'false'
                            }
                        ]}
                    /> */}
          <DefaultMultiSelectVendedores
            paginate={paginate}
            setPaginate={setPaginate}
            formatFilter={formatFilters}
          />
          <MinimalActionButton icon="repeat" label="" action={reloadTable} />
        </div>
      </ActionSection>
      <TableSection stateData={stateData} paginator={Paginator} data={data}>
        <TableContainer
          headers={[
            {
              label: "Número",
              columns: ["codigo"],
              icon: "fa-regular fa-clipboard text-green-600 text-xl",
              className: "flex items-center",
              tag: true,
              // stickyL: true
            },
            {
              label: "Responsable",
              columns: ["nombre_completo", "roles"],
            },
            {
              label: "Efectivo Bs.",
              columns: ["efectivo_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Garantía Bs.",
              columns: ["garantias_total"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Efectivo neto Bs.",
              columns: ["efectivo_total_neto"],
              numberValue: true,
              sumDec: true,
            },
            {
              label: "Abierto / Cerrado",
              columns: ["abierto"],
              boolean: true,
              booleanOptions: ["Abierto", "Cerrado"],
              booleanIconTrue: "fa-check",
              booleanIconFalse: "fa-circle-dot",
            },
            {
              label: "Revisado / Pendiente",
              columns: ["revisado"],
              boolean: true,
              booleanOptions: ["Revisado", "Pendiente"],
              booleanIconTrue: "fa-check",
              booleanIconFalse: "fa-circle-dot",
            },
            {
              label: "fecha de registro",
              columns: ["createdAt"],
              transform: true,
              func: formatDateWithTime,
            },
            ...(!isAnyShow
              ? [
                  {
                    label: "Acciones",
                    actions: [
                      {
                        type: "cyan",
                        icon: "fa-share-from-square",
                        action: (data) => {
                          redirect(`historial/${data.id}/ventas`);
                        },
                        reference: "id",
                        tooltipText: "Detalles de cuaderno",
                        redirect: true,
                      },

                      ...(abierto === true
                        ? [
                            {
                              type: "green",
                              icon: "fa-calendar",
                              action: (data) => { setCurrentData(data); setActualizarFechaModal(true); },
                              tooltipText: "Cambiar fecha",
                              show: (row) => row.revisado === false,
                            },
                          ]
                        : []),
                      ...(abierto === false
                        ? [
                            {
                              type: "green",
                              icon: "fa-rotate-left",
                              action: (data) => {
                                setCurrentData(data);
                                setReopenModal(true);
                              },
                              tooltipText: "Reabrir cuaderno",
                              show: (row) => row.revisado === false,
                            },
                          ]
                        : []),
                      {
                        type: "red",
                        icon: "fa-trash",
                        action: (data) =>
                          UpdateValuesModal(
                            data,
                            setCurrentData,
                            setDeleteModal,
                          ),
                        tooltipText: "Eliminar cuaderno",
                        reference: "id",
                        lock: lock,
                      },
                    ],
                  },
                ]
              : []),
          ]}
          data={data.data}
          doubleClickAction={
            !isAnyShow
              ? (dataItem) => redirect(`historial/${dataItem.id}/ventas`)
              : null
          }
          checkList={true}
          selecteds={selecteds}
          setSelecteds={setSelecteds}
          selectAllChecked={selectAllChecked}
          setSelectAllChecked={setSelectAllChecked}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          stateData={stateData}
        />
      </TableSection>
      {createModal && (
        <ModalForm
          setModal={setCreateModal}
          label="Aperturar cuaderno"
          // dataValues={CreateValues(globalParams.rolname === 'vendedores' ? '/users/permitirCuaderno/vendedores' : '/users/permitirCuaderno/oficina')}
          dataValues={CreateValues("/users/permitirCuaderno/all")}
          urlApi={"/cuadernos"}
          method={"post"}
          call={reloadTable}
          buttonLabel="Registrar"
        />
      )}
      {cerrarCuadernosModal && (
        <ModalForm
          setModal={setCerrarCuadernosModal}
          label="Cerrar cuadernos"
          dataValues={CerrarCuadernosValues(selecteds)}
          urlApi={`/cuadernos/close`}
          method={"put"}
          call={reloadTable}
          buttonLabel="Cerrar"
        />
      )}
      {reopenModal && (
        <ModalForm
          setModal={setReopenModal}
          label={`Reabrir cuaderno ${currentData?.codigo || ""}`}
          dataValues={GeneralUpdateValues(currentData?.id, true)}
          urlApi={`/cuaderno/${currentData?.id}/re-open`}
          method={"put"}
          call={() => {
            reloadTable();
            onReopen?.();
          }}
          buttonLabel="Reabrir"
        />
      )}

      {registroDiarioModal && (
        <ModalPdf setModal={setRegistroDiarioModal}>
          <RegistroDiarioPdf cuadernosids={selecteds} />
        </ModalPdf>
      )}
      {deleteModal && (
        <ModalForm
          setModal={setDeleteModal}
          label="Eliminar cuaderno"
          dataValues={DeleteValues(currentData)}
          urlApi={`/cuaderno/${currentData.id}`}
          method={"delete"}
          call={reloadTable}
          buttonLabel="Eliminar"
        />
      )}
      {actualizarFechaModal && (
        <ModalForm
          setModal={setActualizarFechaModal}
          label={
            <span>
              Actualizar fecha del cuaderno{" "}
              <span className="dark:text-green-500 text-green-600 font-bold">
                {currentData?.codigo}
              </span>
            </span>
          }
          dataValues={UpdateCuadernoValues(currentData)}
          urlApi={`/cuaderno/${currentData?.id}/fechas`}
          method={"post"}
          call={() => {
            setRecall((x) => !x);
          }}
          buttonLabel="Actualizar"
        />
      )}
    </Wrapper>
  );
};
